
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    playerMeta () {
      const meta = {};
      if (this.player.player.country) {
        meta.country = this.player.player.country.name;
      }
      if (this.player.player.dateOfBirth) {
        meta.dob = this.getDate(this.player.player.dateOfBirth);
      }
      if (this.player.player.height && this.player.player.height > 0) {
        meta.height = `${this.player.player.height}cm`;
      }
      if (this.player.player.weight && this.player.player.weight > 0) {
        meta.weight = `${this.player.player.weight}kg`;
      }
      if (this.player.joinDate) {
        meta.joined = this.getDate(this.player.joinDate);
      }
      return meta;
    },
    sponsors () {
      if (this.player.player.sponsors.length) {
        const sortedSponsors = this.player.player.sponsors.slice().sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        return sortedSponsors;
      }
      return null;
    },
    loanedIn () {
      return this.player.onLoanFrom;
    },
    loanedOut () {
      return this.player.onLoanTo;
    },
    loanTitle () {
      return this.loanedIn ? `On Loan From`
        : this.loanedOut ? `On Loan To`
          : null;
    },
    loanValue () {
      return this.loanedIn ? this.loanedIn
        : this.loanedOut ? this.loanedOut
          : null;
    },
    biography () {
      return this.player.player.biography;
    },
  },
};
